import { useState } from "react";
import { Botao } from "../../../shared/components/Botao";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar";
import { ConfirmDeleteModal } from "../../../shared/components/Modal/ConfirmDeleteModal";
import { Navbar } from "../../../shared/components/Navbar";
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";
import { IconAdicionar } from "../../../shared/Icons/IconAdicionar";
import { IconUsuarios } from "../../../shared/Icons/IconUsuarios";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { SimpleFilter } from "../../Contatos/components/SimpleFilter";
import { EditUserModal } from "../components/EditUserModal";
import { UserModal } from "../components/UserModal";
import useGetUsers from "../hooks/useGetUsers";
import deleteUser from "../queries/deleteUser";
import { colunas } from "../util/columnTableUsers";

export function Usuarios() {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [search, setSearch] = useState("");
  const [valueInput, setValueInput] = useState("");
  const [userId, setUserId] = useState<number>();
  const [page, setPage] = useState<number>(1);

  const { data: usuariosData, isLoading } = useGetUsers(search, page);

  const dataSourceUsuarios = usuariosData?.items.map((usuarios: any) => ({
    key: usuarios.UsuarioId,
    ...usuarios,
  }))

  function getForEdit(record: any) {
    setUserId(record.UsuarioId);
    setVisibleEdit(!visibleEdit);
  }

  async function onDelete() {
    userId && await deleteUser(Number(userId))
    setVisibleDelete(!visibleDelete)
    setUserId(undefined)
  }

  const columns = [
    ...colunas,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className="flex gap-3">
            <button
              onClick={() => {
                getForEdit(record);
              }}
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
            >
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>
      <div className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader
          titulo="Usuários"
          icon={<IconUsuarios />}
          componente={
            <div className="flex gap-10">
              <SimpleFilter
                placeholder="Pesquisar usuário"
                value={valueInput}
                onChange={(e: any) => setValueInput(e.target.value)}
                onClick={() => {
                  setSearch(valueInput);
                  if(valueInput) {
                    setPage(1);
                  }
                }}
                onCancel={() => {
                  setSearch("");
                  setValueInput("");
                }}
              />
              <Botao
                texto="Novo"
                icon={<IconAdicionar color="#fff" />}
                onClick={() => setVisible(!visible)}
                className="bg-primary hover:bg-primary-hover text-white"
              />
            </div>
          }
        />

        {visibleEdit ? (
          <EditUserModal
            visible={visibleEdit}
            onCancel={() => {
              setUserId(undefined);
              setVisibleEdit(!visibleEdit);
            }}
            userId={userId!}
            deleteModal={() => {
              setVisibleDelete(!visibleDelete);
              setVisibleEdit(!visibleEdit);
            }}
            setUserId={setUserId}
          />
        ) : (
          <UserModal onCancel={() => setVisible(!visible)} visible={visible} />
        )}

        {!usuariosData ? (
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div> 
        ) : (
          <TableInfo
            loading={isLoading}
            dataSource={dataSourceUsuarios}
            columns={columns}
            pagination={{
              current: page,
              pageSize: usuariosData?.meta?.itemsPerPage,
              total: usuariosData?.meta?.totalItems,
              onChange(p) {
                setPage(p);
              },
            }}
          />
        )}
        <ConfirmDeleteModal
          isModalOpen={visibleDelete}
          title="Deletar Usuário"
          mensagem="Você tem certeza que desejar excluir este usuário?"
          onDelete={onDelete}
          closeModal={() => setVisibleDelete(!visibleDelete)}
        />
      </div>
    </div>
  );
}
